import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateRfqName, UpdateRfqNamePayload } from '../api/updateRfqName';

export const useUpdateRfqName = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateRfqNamePayload) => {
      return await updateRfqName(payload);
    },
    onSuccess: (_data, variables) => {
      // Invalidate the rfq query to refetch with the updated name
      queryClient.invalidateQueries({
        queryKey: ['rfq', variables.rfq_id.toString()]
      });
    }
  });
};
